import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import StatusChip from "@entrilia/shared/components/StatusChip";

interface Props {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  selected: boolean;
  disabled?: boolean;
  pendingApproval?: boolean;
  onClick: () => void;
}

const WorkflowStepMenuItem = ({ icon, title, subtitle, selected, disabled, pendingApproval, onClick }: Props) => {
  return (
    <MenuItem
      selected={selected}
      disabled={disabled}
      onClick={onClick}
      sx={{ gap: 1, "& .MuiChip-root": { flexShrink: 0 } }}
    >
      <ListItemIcon sx={{ minWidth: 0 }}>{icon}</ListItemIcon>
      <ListItemText
        primary={title}
        secondary={subtitle}
        slotProps={{ primary: { noWrap: true }, secondary: { noWrap: true } }}
      />
      {pendingApproval && <StatusChip label="Needs Action" withDot color={(t) => t.palette.warning.main} />}
    </MenuItem>
  );
};

export default WorkflowStepMenuItem;
